/**
 * Check if passed argument exists in passed enum as value.
 *
 * @param {unknown} value Value to check.
 * @param {Object} enumArg Enum to be checked.
 * @returns {boolean}
 */
export function isEnumMember(value, enumArg) {
    return Object.values(enumArg).includes(value);
}
